"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingContent = void 0;
var react_1 = __importStar(require("react"));
var __1 = require("../..");
var LoadingContent_styled_1 = require("./LoadingContent.styled");
var copy_1 = require("./copy");
var Spinner = function (props) { return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100" }, props),
    react_1.default.createElement("path", { fill: "currentColor", d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50" },
        react_1.default.createElement("animateTransform", { attributeName: "transform", attributeType: "XML", type: "rotate", dur: "1s", from: "0 50 50", to: "360 50 50", repeatCount: "indefinite" })))); };
exports.LoadingContent = (0, react_1.forwardRef)(function (_a, ref) {
    var children = _a.children, loading = _a.loading, leftAlign = _a.leftAlign, rest = __rest(_a, ["children", "loading", "leftAlign"]);
    var VisuallyHidden = (0, __1.useComponents)().VisuallyHidden;
    var Copy = (0, __1.useCopy)(copy_1.defaultOptions).Copy;
    return (react_1.default.createElement(LoadingContent_styled_1.StyledLoadingContent, __assign({}, rest, { ref: ref }),
        react_1.default.createElement(LoadingContent_styled_1.StyledLoadingContentLoading, { "$loading": loading, leftAlign: leftAlign },
            react_1.default.createElement(LoadingContent_styled_1.StyledSpinner, { as: Spinner })),
        react_1.default.createElement(LoadingContent_styled_1.StyledLoadingContentContent, { "$loading": loading, "aria-hidden": loading ? 'true' : 'false' }, children),
        react_1.default.createElement(VisuallyHidden, null, loading ? react_1.default.createElement(Copy, { copyKey: "loadingContent.loading" }) : null)));
});
